import { TokenAuthContext } from '@rahtab/auth/lib/token-based-auth';
import { createStackNavigator } from '@rahtab/stack-navigator';
import { NavigationContainer } from '@react-navigation/native';
import type { CheckRequestIdData } from 'hooks/useCheckRequestId';
import type { Load } from 'hooks/useVetApproveHistory';
import React, { useContext, useEffect } from 'react';
import * as Screen from 'screens';
import { clearToken } from 'hooks/useToken';

const Stack = createStackNavigator();

const Router: React.VFC = () => {
  const { isSignout } = useContext(TokenAuthContext);

  useEffect(() => {
    clearToken();
  }, [isSignout]);

  return (
    <NavigationContainer>
      <Stack.Navigator authorizationOptions={{ isSignout }} screenOptions={{ headerShown: false }}>
        <Stack.Screen name="Landing" options={{ access: 'protected' }} component={Screen.Landing} />
        <Stack.Screen name="Home" options={{ access: 'private' }} component={Screen.Home} />
        <Stack.Screen name="Support" options={{ access: 'private' }} component={Screen.Support} />
        <Stack.Screen name="VerifiedLoadInfo" options={{ access: 'private' }} component={Screen.VerifiedLoadInfo} />
        <Stack.Screen
          name="VerifiedLoadsHistory"
          options={{ access: 'private' }}
          component={Screen.VerifiedLoadsHistory}
        />
        <Stack.Screen name="SubmitLoadInfo" options={{ access: 'private' }} component={Screen.SubmitLoadInfo} />
        <Stack.Screen
          name="SubmitConsigmentInfo"
          options={{ access: 'private' }}
          component={Screen.SubmitConsigmentInfo}
        />
        <Stack.Screen
          name="SubmitShipmentGenericVet"
          options={{ access: 'private' }}
          component={Screen.SubmitShipmentGenericVet}
        />
        <Stack.Screen name="LoadInquiry" options={{ access: 'private' }} component={Screen.LoadInquiry} />
        <Stack.Screen name="SearchProvider" options={{ access: 'private' }} component={Screen.SearchProvider} />
        <Stack.Screen name="StoreInventory" options={{ access: 'private' }} component={Screen.StoreInventory} />
        <Stack.Screen
          name="MerchandiseInventory"
          options={{ access: 'private' }}
          component={Screen.MerchandiseInventory}
        />
        <Stack.Screen name="LoadsList" options={{ access: 'private' }} component={Screen.LoadsList} />
        <Stack.Screen name="ReceivedLoad" options={{ access: 'private' }} component={Screen.ReceivedLoad} />
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default Router;

export type RootStackType = {
  Landing: undefined;
  Home: undefined;
  Support: undefined;
  VerifiedLoadInfo: Load;
  VerifiedLoadsHistory?: {
    refetch?: boolean;
  };
  SubmitLoadInfo?: Partial<CheckRequestIdData>;
  SubmitConsigmentInfo?: Partial<CheckRequestIdData>;
  SubmitShipmentGenericVet?: Partial<CheckRequestIdData>;
  LoadInquiry?: Partial<CheckRequestIdData>;
  SearchProvider: {
    type: 'شناسه' | 'کد ملی' | 'مشخصات';
    value: string;
  };
  StoreInventory: {
    providerCode: string;
  };
  MerchandiseInventory: {
    id: string;
    providerCode: string;
  };
  LoadsList: {
    merchandiseId: string;
    providerCode: string;
  };
  ReceivedLoad: {
    merchandiseId: string;
    assignFinalCode: string;
  };
};
